import React from 'react';
import { PlayIcon } from 'lucide-react';
import { HeroBackground } from './HeroBackground';
export function Hero() {
  const featuredGames = [{
    title: 'Wall Street Bets: Stonks and Gains',
    image: 'https://cinderella-prod.s3.us-east-2.amazonaws.com/games/135/cover.webp?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAXEVXYPT4NHCBPY5G%2F20251105%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20251105T054802Z&X-Amz-Expires=3600&X-Amz-Signature=348cb137f5b14a8e3b52a32858eb2f886428223934bb9f7ee6928d7280df4ae2&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject',
    playUrl: 'https://play.fifthdoor.com/games/wall-street-bets',
    remixUrl: 'https://play.fifthdoor.com/games/wall-street-bets'
  }, {
    title: 'Political Poker',
    image: 'https://cinderella-prod.s3.us-east-2.amazonaws.com/games/118/cover.webp?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAXEVXYPT4NHCBPY5G%2F20251105%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20251105T051427Z&X-Amz-Expires=3600&X-Amz-Signature=449429709df82064b1e45ffaa4c85af78f8d92b4c49e9bdbfdeb670a18e8a086&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject',
    playUrl: 'https://play.fifthdoor.com/games/new-game-u3bwgc',
    remixUrl: 'https://play.fifthdoor.com/games/new-game-u3bwgc'
  }, {
    title: "The Apprentice's Apprentice",
    image: 'https://cinderella-prod.s3.us-east-2.amazonaws.com/games/121/cover.webp?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIAXEVXYPT4NHCBPY5G%2F20251105%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20251105T051427Z&X-Amz-Expires=3600&X-Amz-Signature=88789ee02a3dcddc1adc7973e33f68821899a4461dfa9f2a1eaed7a5cfd172cf&X-Amz-SignedHeaders=host&x-amz-checksum-mode=ENABLED&x-id=GetObject',
    playUrl: 'https://play.fifthdoor.com/games/apprentices-apprentice',
    remixUrl: 'https://play.fifthdoor.com/games/apprentices-apprentice'
  }];
  return <section className="w-full px-4 relative overflow-hidden flex items-center" style={{
    height: 'calc(100vh - 64px)'
  }} data-id="element-53">
      {/* Animated Three.js Background */}
      <HeroBackground data-id="element-54" />
      {/* Content */}
      <div className="max-w-6xl mx-auto text-center relative z-10 w-full py-12" data-id="element-55">
        <div className="rounded-3xl px-8 py-12 md:px-16 md:py-16" style={{
        backgroundColor: 'rgba(212, 175, 113, 0.15)',
        backdropFilter: 'blur(1px)',
        WebkitBackdropFilter: 'blur(1px)',
        boxShadow: '0 8px 32px 0 rgba(212, 175, 113, 0.1)'
      }} data-id="element-56">
          <p className="text-4xl md:text-6xl font-semibold text-gray-900 mb-4" data-id="element-57">
            Create. Play. Anytime.
          </p>
          <p className="text-lg md:text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-58">
            Build a game from idea to playable in minutes. No coding required.
            <br data-id="element-59" />
            Just pure creativity and endless possibilities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-60">
            <a href="https://game.fifthdoor.com/launch" className="px-8 py-4 text-white rounded-full font-semibold text-lg hover:shadow-md transition-all duration-300 hover:scale-105 flex items-center gap-2" style={{
            background: 'linear-gradient(135deg, #31192E 0%, #4a2d47 50%, #8b7355 100%)'
          }} data-id="element-61">
              <PlayIcon className="w-5 h-5" data-id="element-62" />
              Play Game
            </a>
            <a href="https://discord.gg/HCC76Zt82Y" target="_blank" rel="noopener noreferrer" className="px-8 py-4 text-white rounded-full font-semibold text-lg hover:shadow-md transition-all duration-300 hover:scale-105 flex items-center gap-2" style={{
            background: 'linear-gradient(135deg, #31192E 0%, #4a2d47 50%, #8b7355 100%)'
          }} data-id="element-63">
              Join Discord
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bCTwQuQg1RHyDN81pzL1uF/discord-icon-43736.png" alt="Discord" className="w-5 h-5 brightness-0 invert" data-id="element-64" />
            </a>
          </div>
          <p className="text-m md:text-l text-gray-600 max-w-xl mx-auto" data-id="element-65">
            <br data-id="element-66" />
            Fifth Door is in private beta. Join our Discord channel to get on
            the waitlist.
          </p>
          {/* Featured Games Carousel */}
          {/* <div className="mt-16 mb-16">
           <h3 className="text-2xl font-semibold text-gray-900 mb-8">
           Featured Games
           </h3>
           <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
           {featuredGames.map((game, index) => (
           <div
           key={index}
           className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col"
           >
           <div className="relative h-48 overflow-hidden">
           <img
           src={game.image}
           alt={game.title}
           className="w-full h-full object-cover"
           />
           <div
           className="absolute inset-0"
           style={{
           background:
           'linear-gradient(180deg, transparent 0%, rgba(49, 25, 46, 0.4) 100%)'}}
           />
           </div>
           <div className="p-6 flex flex-col flex-grow">
           <h4 className="text-xl font-semibold text-gray-900 mb-4 min-h-[3.5rem]">
           {game.title}
           </h4>
           <div className="flex gap-3 mt-auto">
           <a
           href={game.playUrl}
           className="flex-1 px-4 py-3 bg-white border-2 rounded-xl font-semibold text-sm hover:shadow-md transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
           style={{
            borderColor: '#D4AF71',
            color: '#31192E'}}
           >
           <PlayIcon className="w-4 h-4" />
           Play
           </a>
           <a
           href={game.remixUrl}
           className="flex-1 px-4 py-3 text-white rounded-xl font-semibold text-sm hover:shadow-md transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2"
           style={{
            background:
              'linear-gradient(135deg, #31192E 0%, #4a2d47 50%, #8b7355 100%)'}}
           >
           <SparklesIcon className="w-4 h-4" />
           Remix
           </a>
           </div>
           </div>
           </div>
           ))}
           </div>
           {/*
           <div className="mt-16 grid grid-cols-3 gap-8 max-w-2xl mx-auto">
           <div>
           <p
           className="text-4xl font-bold"
           style={{
           color: '#D4AF71'}}
           >
           10K+
           </p>
           <p className="text-gray-600 mt-2">Games Remixed</p>
           </div>
           <div>
           <p
           className="text-4xl font-bold"
           style={{
           color: '#D4AF71'}}
           >
           50K+
           </p>
           <p className="text-gray-600 mt-2">Creators</p>
           </div>
           <div>
           <p
           className="text-4xl font-bold"
           style={{
           color: '#D4AF71'}}
           >
           1M+
           </p>
           <p className="text-gray-600 mt-2">Plays</p>
           </div>
           </div>
           */}
        </div>
      </div>
    </section>;
}